import { render, staticRenderFns } from "./CadastroHome.vue?vue&type=template&id=22b5d309"
import script from "./CadastroHome.vue?vue&type=script&lang=js"
export * from "./CadastroHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports